import { useTitle } from "@/hooks/use-title.hook.ts";
import { useDocumentFoldersList } from "@/queries/use-documents.query.ts";
import { ApiFolderType, folderParamKeys } from "@/types/document.types.ts";
import { useTranslation } from "react-i18next";
import { Documents } from "@/components/documents/Documents.tsx";
import { Page, Stack } from "@skailer-com/uikit";
import { useSearchParams } from "react-router-dom";

export default function DocumentFoldersPage() {
  const { t } = useTranslation();
  useTitle(t("core:document_folders"), t("core:documents"));

  const [searchParams] = useSearchParams();
  const hasOpenEmployeeFolder = searchParams.has(folderParamKeys[ApiFolderType.employee]);
  const hasOpenOrgFolder = searchParams.has(folderParamKeys[ApiFolderType.organization]);

  const { data: employeeFolders, isLoading: isEmployeeFoldersLoading } = useDocumentFoldersList(
    ApiFolderType.employee
  );
  const { data: orgFolders, isLoading: isOrgFoldersLoading } = useDocumentFoldersList(
    ApiFolderType.organization
  );

  return (
    <Page>
      <Page.Header
        showBack={true}
        title={t("core:document_folders")}
        navigateTo={"/docs"}
      ></Page.Header>
      <Page.Content>
        <Stack className={"pt-8 px-16 gap-16"}>
          {!hasOpenOrgFolder && (
            <Documents
              folders={employeeFolders || []}
              isLoading={isEmployeeFoldersLoading}
              foldersType={ApiFolderType.employee}
              showManageFolders
            />
          )}
          {!hasOpenEmployeeFolder && (
            <Documents
              folders={orgFolders || []}
              isLoading={isOrgFoldersLoading}
              foldersType={ApiFolderType.organization}
              showManageFolders
            />
          )}
        </Stack>
      </Page.Content>
    </Page>
  );
}
